import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {closeFindPeopleForm, performSearch, handleSearchPeople} from '../../actions/navOptions';
import {totalAvailableSpots} from '../../utils';
import ParkingSpotSearchResult from './ParkingSpotSearchResult';
import _ from 'lodash';

class FindPeopleForm extends Component {

  constructor(props) {
    super(props);

    this.performSearch = _.debounce(this.props.performSearch, 1000);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount () {
    this.searchInput.focus();
    let affixDivWidth = $(this.affixDiv).outerWidth();
    let affixDivHeight = $(this.affixDiv).outerHeight();
    $(this.affixDiv).affix({
      offset: {
        top: $(this.affixDiv).offset().top,
        bottom: 0
      }
    });
    $(this.affixDiv).on('affixed.bs.affix', function(){
      $(this).css('width', affixDivWidth);
      $(this).find('input').css('width', (affixDivWidth - 50));
      $("ul.auto-suggest-people").css('margin-top', affixDivHeight);
    });
    $(this.affixDiv).on('affixed-top.bs.affix', function(){
      $(this).css('width', 'auto');
      $(this).find('input').css('width', '100%');
      $("ul.auto-suggest-people").css('margin-top', '0px');
    });
  }

  handleSearch(e) {
    this.props.handleSearchPeople(e.target.value);
    this.performSearch();
  }

  renderSearchResults() {
    let { result = [], query,  isLoading} = this.props;

    if (!result.length && !isLoading && query) {
      return (
        <div className="color-danger">
          <em>
            no results found
          </em>
        </div>
      );
    }

    // Need to consolidate attendees with duplicate assignments so they don't render multiple times
    const combinedResults = Object.values(result.reduce((acc, attendee) => {
      if (!acc[attendee.uidAssignment]) {
        acc[attendee.uidAssignment] = {
          avatar: attendee.avatar,
          firstName: attendee.firstName,
          lastName: attendee.lastName,
          classInfo: [{
            class: attendee.class,
            vehicleNumber: attendee.vehicleNumber
          }],
          uidAssignment: attendee.uidAssignment,
          spotIdentifier: new Set(attendee.spotIdentifier)
        };
      } else {
        if (!attendee.classInfo) {
          attendee.classInfo = []
        }

        attendee.classInfo.push({
          class: attendee.class,
          vehicleNumber: attendee.vehicleNumber
        });
        attendee.spotIdentifier.forEach((spot) => acc[attendee.uidAssignment].spotIdentifier.add(spot))
      }

      return acc;
    }, {}));

    const formattedResult = Object.values(combinedResults).map((result) => ({
      ...result,
      spotIdentifier: [...result.spotIdentifier]
    }))

    return formattedResult.map((searchData, i) => {
      return <ParkingSpotSearchResult data={searchData} key={i} />;
    });
  }


  render() {
    const {query, isLoading} = this.props;
    const spotsAvailable = totalAvailableSpots();

    return (
      <div className="map-page map-page__default">
        <div className="map-page-content" id="page-people">
          <div className="map-page-content-head clearfix">
            <h2 className="pull-left"><div className="icon-people" />People</h2>
            <a href="#" className="close-it hide-map-page pull-right" onClick={this.props.closeFindPeopleForm}>&times;</a>
          </div>
          {/*<!-- //.map-page-content-head -->*/}
          <div className="map-page-body">

            <form action="">
              <div className="form-group"
                   ref={(el) => { this.affixDiv = el; }}
                   data-spy="affix"
              >
                <a href="#" className="close-it hide-map-page pull-right" onClick={this.props.closeFindPeopleForm}>&times;</a>
                <input type="text"
                       ref={(input) => { this.searchInput = input; }}
                       className={isLoading ? "form-control loading": "form-control"}
                       placeholder="Begin typing..."
                       onChange={this.handleSearch}
                       value={query}
                />
              </div>

              <ul className="auto-suggest-people">
              <small><i className="fa fa-info-circle color-primary" />&nbsp;Search first/last names, classes, groups, and vehicle numbers</small>
                {this.renderSearchResults()}
              </ul>
            </form>

          </div>
          {/*<!-- //.map-page-body -->*/}
          <div className="map-page-content-footer">
            {/*<!-- <hr>*/}
            {/*<a href="" className="btn btn-primary btn-block btn-lg">Show 92 spots</a> -->*/}
          </div>
        </div>
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  const { query, result, isLoading } = state.search;
  return {
    query,
    result,
    isLoading
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ closeFindPeopleForm, performSearch, handleSearchPeople }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FindPeopleForm);



// WEBPACK FOOTER //
// ./src/containers/Search/FindPeopleForm.js